export default __webpack_public_path__ + "static/media/roundIcon.85619066.png";